<template>
	
	<div>
		<div v-for="(item,index) in partList" class="grey-bg-sec">

			<mt-cell-swipe  
				class="cart-swiper"
				:right="[
					    {
					      content: '删除',
					      style: { 
					      	background: 'red',
					      	color: '#fff'
					      	},
					      handler: () => { delCartItem(item,index)}
					    }
				  	]"
			  	>
			  	<div class="pro-table-sec">
					<div class="pro-table">
						<div class="pro-table-left">
							<span class="checkbox-group">
								<input type="checkbox" class="input-checkbox"  
									:value="item.uniqueId" 
									v-model="subProChecked"
									@change="checkedToggle($event,item)"								
								v-if="item.saleStatus ==2 || isEdite==true">
								<input v-else  type="checkbox" class="input-checkbox" disabled="">
								<span class="icon-checkbox"></span>
							</span>
						</div>
						<div class="pro-table-right">
							<router-link :to="{ path: '/productdetail/'+item.goodsChannelId, query: { url: router }}">
								<div class="media">
									<div class="media-left">
										<img :src="item.thumb" alt="" v-if="!!item.thumb">
										<img src="../../../assets/images/default-pro-small.png" alt="" v-else>
									</div>
									<div class="media-content">
										<p class="m-title">
											<span>{{item.goodsName}}</span>
											<span class="m-small">{{item.skuPropertyValue}}</span>
										</p>
										<span class="m-subTitle" v-if="item.giftContent"><span class="label">赠品</span>{{item.giftContent}}</span>
										<div class="m-operate">
											<div class="m-operate-cont">
												<span class="price text-red">¥{{item.salePrice | filterPrice}}</span>
												<counter
													:index = 'index'
													:item = 'item'
													:count = 'item.goodsNum' 
													:saleStatus = 'item.saleStatus'
													v-on:reduce = 'updateNum'
													v-on:plus = 'updateNum'
												></counter>
											</div>
										</div>
									</div>
								</div>
							</router-link>
						</div>
					</div>
					<div class="pro-table-footer" v-if="item.chooseBirthdayCart">
						<span class="birth-brand">生日牌</span>
						<span :class="{'text-grey': !item.birthdayCardContent}" @click="birthPopup(item)">{{item.birthdayCardContent ? item.birthdayCardContent :'如需要可点击添加'}}<span class="icon-arrow-right"></span></span>
					</div>
					<div class="pro-table-footer part-table-footer topBorder" v-if="item.chooseGreetingCard">
							<span class="birth-brand">祝福贺卡</span>
							<span class="text-grey">
								<input type="text" class="part-mark"
								placeholder="如需要可点击添加" 
								v-model="item.greetingCardContent"
								@change = "undateGreetingCard($event,item)"
							/></span>
					</div>
				</div>
			</mt-cell-swipe>
		</div>
	</div>
</template>



<script>
	import Vue from 'vue';
	import { MessageBox } from '@/js/mint-ui'
	import { CellSwipe } from '@/js/mint-ui';
  	import { Toast } from '@/js/mint-ui';
	Vue.component(CellSwipe.name, CellSwipe);
	import { Popup } from '@/js/mint-ui';
	Vue.component(Popup.name, Popup);
	

	import counter from '../counter'

	export default {
		props: ['partList','proChecked','isEdite'],
		data(){
			return {
			}
		},
		components: {
			counter
		},
		computed:{
			router(){
		        if (this.isProCart ) {
		          return this.$route.fullPath + '?isProCart=true'
		        } else {
		          return this.$route.fullPath;
		        }

		    },
		  	path () {
		        return this.$route.query['url']
		    },
		    subProChecked(){
		    	const list = [];
		    	this.partList.map((item,index)=>{
		    		if(item.checked){
		    			list.push(item.uniqueId)
		    		}
		    	})	
		    	return list;
		    }

		},
		methods: {
			delCartItem(item,index){
				this.$emit('delCartItem',item)
			},
			checkedToggle($event,item){
				this.$emit('subCheckedToggle',$event,item)
			},
			updateNum(count,item,index){
				this.$emit('updateNum',count,item,index)

			},
			birthPopup(item){
				this.$emit('birthPopup',item)
			},
			undateGreetingCard($event,item){
				this.$emit('undateGreetingCard',$event,item)
			}
		}
	}
	
</script>


// WEBPACK FOOTER //
// shopCartComList.vue?5295a244